export default __webpack_public_path__ + "static/media/white beanie.7ee5dc75.png";